<template>
  <section class="reviews-faq" aria-labelledby="reviews-faq-title">
    <h2 id="reviews-faq-title" class="reviews-faq__title">Частые вопросы об отзывах</h2>
    <ul class="reviews-faq__list">
      <li
        v-for="item in items"
        :key="item.id"
        class="reviews-faq__item"
        :class="{ 'is-open': openId === item.id }"
      >
        <button
          type="button"
          class="reviews-faq__question"
          :aria-expanded="openId === item.id ? 'true' : 'false'"
          @click="toggle(item.id)"
        >
          <span>{{ item.question }}</span>
          <span class="reviews-faq__icon" aria-hidden="true">{{ openId === item.id ? '−' : '+' }}</span>
        </button>
        <div v-show="openId === item.id" class="reviews-faq__answer">
          <p>{{ item.answer }}</p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'ReviewsFaq',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      openId: null,
    }
  },
  methods: {
    toggle(id) {
      this.openId = this.openId === id ? null : id
    },
  },
}
</script>
